import React, { useEffect } from "react";
import {Button, Col, Form, InputNumber, Radio, Row, Switch, Tooltip} from "antd";
import { SettingInterface } from "src/store/community/settingsSlice";

import '../Settings.scss';
import {DollarOutlined, QuestionCircleOutlined} from "@ant-design/icons";

interface propsInterface {
  onFinish: Function;
  params?: SettingInterface['data'] | undefined;
}

const _Community = ({ onFinish, params }: propsInterface) => {
  const [form] = Form.useForm();
  const publishTypeValue = Form.useWatch(['post_publish', 'purchase_type'], form);
  const purchaseTypeValue = Form.useWatch(['community_purchase', 'purchase_type'], form);
  const rulesValue = Form.useWatch(['community_purchase', 'bundle_rules'], form);

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      className='v-form v-settings-form'
      layout="vertical"
      autoComplete="off"
      initialValues={params}
    >
      <h6 className="v-content-label o-sm">
        Create Defaults

        <Tooltip title="This values will be set to each post on publish">
          <QuestionCircleOutlined />
        </Tooltip>
      </h6>

      <Form.Item
        label="Purchase by"
        tooltip='When ads selected, user can purchase post by watching ads or paying coins'
        name={['community_create', 'purchase_type']}
      >
        <Radio.Group>
          <Radio.Button value="free">free</Radio.Button>
          <Radio.Button value='coins'>coins</Radio.Button>
          <Radio.Button value='ads'>ads</Radio.Button>
        </Radio.Group>
      </Form.Item>

      <Form.Item
        name={['community_create', 'coins']}
        rules={[{ required: true, message: 'Missing value' }]}
        label='Cost'
        className='v-mb-30'
      >
        <InputNumber
          min={0}
          step={5}
          placeholder='5'
          prefix={<DollarOutlined />}
        />
      </Form.Item>

      <h6 className="v-content-label o-sm">Purchase settings</h6>

      <Form.Item
        label="Purchase by"
        tooltip='When ads selected, user can purchase post by watching ads or paying coins'
        name={['community_purchase', 'purchase_type']}
      >
        <Radio.Group disabled={rulesValue === false}>
          <Radio.Button value="free">free</Radio.Button>
          <Radio.Button value='coins'>coins</Radio.Button>
          <Radio.Button value='ads'>ads</Radio.Button>
        </Radio.Group>
      </Form.Item>

      <Row gutter={8}>
        <Col span={12}>
          <Form.Item
            name={['community_purchase', 'free_actions']}
            rules={[{ required: true, message: 'Missing value' }]}
            label='Free actions'
          >
            <InputNumber
              min={0}
              placeholder='3'
              disabled={purchaseTypeValue === 'free'}
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            name={['community_purchase', 'coins']}
            rules={[{ required: true, message: 'Missing value' }]}
            label='Cost'
          >
            <InputNumber
              min={0}
              step={5}
              placeholder='5'
              prefix={<DollarOutlined />}
              disabled={purchaseTypeValue === 'free' || rulesValue === false}
            />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item
        name={['community_purchase', 'bundle_rules']}
        valuePropName='checked'
        extra='when enabled, will be used PURCHASE SETTINGS, otherwise "Bundle" CREATE DEFAULTS settings'
        className='v-mb-30'
      >
        <Switch />
      </Form.Item>

      <h6 className="v-content-label o-sm">Publish settings</h6>

      <Form.Item
        label="Publish by"
        tooltip='When ads selected, user can publish post by watching ads or paying coins'
        name={['post_publish', 'purchase_type']}
      >
        <Radio.Group>
          <Radio.Button value="free">free</Radio.Button>
          <Radio.Button value='coins'>coins</Radio.Button>
          <Radio.Button value='ads'>ads</Radio.Button>
        </Radio.Group>
      </Form.Item>

      <Row gutter={8}>
        <Col span={12}>
          <Form.Item
            name={['post_publish', 'free_actions']}
            rules={[{ required: true, message: 'Missing value' }]}
            label='Free actions'
          >
            <InputNumber
              min={0}
              placeholder='3'
              disabled={publishTypeValue === 'free'}
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            name={['post_publish', 'coins']}
            rules={[{ required: true, message: 'Missing value' }]}
            label='Cost'
          >
            <InputNumber
              min={0}
              step={5}
              placeholder='5'
              prefix={<DollarOutlined />}
              disabled={publishTypeValue === 'free'}
            />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Apply
        </Button>
      </Form.Item>
    </Form>
  );
}

export default _Community;
